module.exports = __webpack_public_path__ + "img/title.799490c9.png";